/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */

export default () => {
  const siteNavigation = document.getElementById("site-navigation");
  if (!siteNavigation) {
    console.warn(
      "id.site-navigationがないためnavigation.jsを実行できませんでした"
    );
    return;
  }
  const menu = siteNavigation.getElementsByTagName("ul")[0];
  if (!menu.classList.contains("nav-menu")) {
    menu.classList.add("nav-menu");
  }

  // ハンバーガー
  var hum = document.getElementById("hum_toggle");
  var nav = document.getElementById("site-navigation");
  var link = document.querySelectorAll("#site-navigation a");
  var html = document.documentElement;
  var body = document.body;
  var wid = false; // pcサイズならtrueを返す
  var timeoutId;

  hum.addEventListener("click", function () {
    hum.classList.toggle("active");
    nav.classList.toggle("active");
    body.classList.toggle("hum_active");
    html.classList.toggle("hum_active");
  });

  function widWatch() {
    const x = window.innerWidth;
    if (x >= 1025) {
      wid = true;
    } else {
      wid = false;
    }
    return;
  }

  window.addEventListener(
    "resize",
    () => {
      widWatch();
      body.setAttribute("id", "preload");
      clearTimeout(timeoutId);
      timeoutId = setTimeout(function () {
        body.removeAttribute("id", "preload");
      }, 500);
    },
    false
  );

  function linkClick() {
    link.forEach((elm) => {
      elm.addEventListener("click", closeAction);
    });
  }
  function closeAction() {
    hum.classList.remove("active");
    nav.classList.remove("active");
    body.classList.remove("hum_active");
    html.classList.remove("hum_active");
  }
  // function pcAction(e) {
  //   let parent = e.target.closest('.header-navigation .nav-menu > li')
  //   nav.classList.remove('activeOn')
  //   parent.addEventListener(
  //     'mouseleave',
  //     () => {
  //       nav.classList.add('activeOn')
  //     },
  //     false
  //   )
  // }
  // function spAction() {
  //   console.log('spAction')
  //   hum.classList.remove('active')
  //   nav.classList.remove('active')
  //   body.classList.remove('hum_active')
  //   html.classList.remove('hum_active')
  // }

  window.addEventListener(
    "DOMContentLoaded",
    () => {
      widWatch();
      linkClick();
    },
    false
  );
};
